module.exports = __webpack_public_path__ + "videos/about-768@2x.a30e178.webm";